let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gf7Uy")).then(() => parcelRequire('lrPpP'));